import { atom } from "jotai";

// One preference for every report, retained while navigating between pages.
export const reportingIntervalAtom = atom("auto");

export const reportingIntervals = [
  { value: "auto", label: "Auto" },
  { value: "day", label: "Daily" },
  { value: "week", label: "Weekly" },
  { value: "month", label: "Monthly" },
];
